function stocklevels2() {
  $("#masterProduct .single-option-selector").each(function(index, element) { 

      // Get's the ID of the select element. 
      var elementId = $(this).attr("id");
    
      // Loop through each selects option.
      $("#masterProduct #"+elementId+ " option").each(function(id, value) {

          var optionId = $(this).val();
          var existingValue = $(this).text();
        
          //This code checks if the option is a complex stock level or not. 
          var stock_level = [];
        
          $("#avail-list td.stockMatch[data-stockmatch='"+optionId+"']").each(function(id, value) {
            	
              $(this).next('.complexstocklevel').children('span').each(function(id, value) {
                   var text = $(this).text();
                   stock_level.push($.trim(text));
              });
          });
        
          if(stock_level.length > 0) {

              var stock_output = stock_level.join(" ");

              var new_value = existingValue + ' - ' + $.trim(stock_output);

              $(this).text(new_value);
          }
        
      });
  });
  
};

$( document ).ready(function() {
  setTimeout(function() {
           stocklevels2();
        }, 500);
});